import React from 'react';
import { InstagramEmbed } from 'react-social-media-embed';
import { InstagramLogoIcon } from '@radix-ui/react-icons';

const Medsos = () => {
    const images = [
        "https://www.instagram.com/p/DKU2wBMTff1/?next=%2F&img_index=1",
        // "https://www.instagram.com/p/DKTeRBdTZlJ/?next=%2F",
        // "https://www.instagram.com/p/DKZQ759C7NP/?next=%2F",
    ];

    return (
        <section className="flex flex-col lg:flex-row items-center justify-between px-6 py-12 gap-10 max-w-7xl mx-auto">
            {/* Left text */}
            <div className="max-w-sm text-center lg:text-left">
                <h2 className="text-2xl font-bold mb-4">Let’s Get Away</h2>
                <p className="text-gray-600 mb-4">
                    A holiday is a special time to relax and enjoy with family or friends.
                    It helps us recharge and create happy memories.
                </p>
                <a
                    href="https://www.instagram.com/alamwisataanugerah"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center text-sky-600 hover:underline font-semibold"
                >
                    <InstagramLogoIcon className="w-5 h-5 mr-2" />
                    @alamwisataanugerah
                </a>
            </div>

            {/* Instagram phone mockup */}
            <div className="flex flex-col lg:flex-row items-center gap-6">
                <img
                    src="../image/phone.png"
                    alt="Instagram Phone Mockup"
                    className="w-64 rounded-xl shadow-lg"
                />
                <div className="grid grid-cols-2 gap-4">
                    {/* Content above overlay */}
                    <div className="relative max-w-7xl mx-auto">
                        {/* <h1 className="text-3xl font-extrabold mb-8 text-center">Media Sosial</h1> */}
                        {/* <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6"> */}
                        {images.map((url, index) => (
                            <InstagramEmbed key={index} url={url} className="w-full h-100 object-cover rounded-xl" />
                        ))}
                        {/* </div> */}
                    </div>
                </div>
            </div>
        </section>


    );
};

export default Medsos;
